<template>
    <el-dialog :visible.sync="visible" class="ele-toast"  width="860px" :before-close="resetForm" :close-on-click-modal="false">
        <div slot="title">
            <z-title title="婚庆订单确认收款"></z-title>
            <div class="rulefrom2 lh-30">
                <weddingbase :info="info"></weddingbase>
                <el-divider></el-divider>
                <el-table
                        cell-class-name="cellclass"
                        :data="dataList"
                        :summary-method="getSummaries"
                        show-summary
                        style="width:100%">
                    <el-table-column
                            fixed
                            align="center"
                            label="序 号"
                            min-width="90">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="审核日期"
                            min-width="180"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="金额类型"
                            min-width="80"
                            align="center">
                        <template slot-scope="scope">
                            <div class="ptb-10">
                                <el-tag v-if="scope.row.confirmType==0" size="mini" type="success">入账</el-tag>
                                <el-tag v-else-if="scope.row.confirmType==1" size="mini" type="danger">退款</el-tag>
                                <el-tag v-else size="mini" type="warning">补账</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="审核事项"
                            min-width="180"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="confirmName"
                            label="审核人员"
                            min-width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="确认收款金额"
                            width="160"
                            align="center">
                        <template slot-scope="scope">
                            {{scope.row.confirmType==1?'-':''}}{{scope.row.confirmMoney}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="收款时间"
                            width="160"
                            align="center">
                        <template slot-scope="scope">
                            {{scope.row.confirmType==1?'-':''}}{{scope.row.confirmMoney}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="入账账户"
                            width="100"
                            align="center">
                        <template slot-scope="scope">
                            {{scope.row.confirmType==1?'-':''}}{{scope.row.confirmMoney}}
                        </template>
                    </el-table-column>
                </el-table>
                <!--订单确认收款-->
                <el-form :model="dataForm" :rules="rules" ref="ruleForm" class=" mt-10" size="medium">
                    <!--<el-form-item label="确认收款金额" :show-message="false" prop="confirmMoney" label-width="110px">-->
                        <!--<el-input placeholder="请输入收款金额" class="w-170" v-model="dataForm.confirmMoney"-->
                                  <!--v-number="{precision:2,max:100000}">-->
                        <!--</el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="补账时间" :show-message="false" prop="operateTime" label-width="110px">
                        <el-date-picker
                                v-model="dataForm.operateTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="入账账户" prop="paylist" label-width="110px">
                        <div class="flex-n fac">
                            <payment type="object" v-model="dataForm.paylist"
                                     multiple placeholder="请选择支付方式"
                                     class="w-520"></payment>
                        </div>
                    </el-form-item>

                    <div class="plr-20">
                        <div class="flex-w">
                            <el-form-item :label="item.dicName" v-for="(item,index) in dataForm.paylist"  label-width="90px">
                                <el-input-number :controls="false" class="w-120" placeholder="￥" v-model="item.price"
                                                 :precision="2" :step="0.1" controls-position="right"
                                                 :max="9999999999"></el-input-number>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item label="审核事项" prop="remark" label-width="110px">
                        <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                                  maxlength="512"></el-input>
                    </el-form-item>
                    <el-form-item class="mt-10 flex-n fje">
                        <el-button type="primary" @click="submit('ruleForm')">
                            确认补账
                        </el-button>
                        <el-button @click="resetForm">取 消</el-button>
                    </el-form-item>
                </el-form>

            </div>

        </div>
    </el-dialog>

</template>

<script>
    import ZTitle from "../../../components/ZTitle";
    import Orderbase from "../../component/orderbase";
    import Weddingbase from "../../component/weddingbase";
    import Payment from "../../../components/data/payment";

    export default {
        components: {
            Payment,
            Weddingbase,
            Orderbase,
            ZTitle},
        name: "wed-supplementary-account",
        props:{
            visible: Boolean,
            id: String,
            wedId:String
        },
        data() {
            var checkconfirmMoney = (rule, value, callback) => {
                console.log(value)
                if (value == '') {
                    return callback(new Error(' '));
                }
                if (Number(value) == 0) {
                    this.$message.error('输入金额必须大于零！');
                    return callback(new Error(' '));
                }
                return callback();
            };
            return {
                dataList: [],
                loading:false,
                currentPage: 1,
                pageSize: 20,
                total: 0,
                info:{},
                //确认收款
                dataForm: {
                    // confirmMoney: '',
                    remark: '',
                    paylist:[],
                    operateTime:''
                },
                rules: {
                    operateTime:[{required: true, message: ' ', trigger: 'change'}],
                    // memberPhone: [{validator: validatetel, trigger: 'blur'},
                    //     {required: true, message: ' ', trigger: 'change'}],
                    // confirmMoney: [{required: true, validator: checkconfirmMoney, trigger: 'blur'}],
                    paylist:[{required: true, message: ' ', trigger: 'change'}],
                },
            }
        },
        watch:{
            visible(newval,oldval){
                if(newval){
                    this.getData();
                    this.getInfo();
                }
            }
        },
        methods:{
            //婚庆收款明细
            getData(){
                this.$axios.get('/weddingFinanceConfirm/financeWeddingConfirmDetail/' + this.wedId).then(res => {
                    console.log(res)
                    this.dataList = res.data.list;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            getInfo(){
                //上半部基本信息
                this.$axios.get('/wedding/orderWeddingDetail/' + this.wedId).then(res => {
                    console.log(res)
                    var info = res.data;
                    this.info = info;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var dataForm = this.dataForm;
                        var payment=[];
                        for (var i in this.dataForm.paylist) {
                            payment.push({
                                "payMoney": this.dataForm.paylist[i].price||0,
                                "paymentCode": this.dataForm.paylist[i].dicCode,
                                "paymentName": this.dataForm.paylist[i].dicName,
                            })
                        }
                        this.$axios.post('/weddingFinanceConfirm/saveWeddingReceivable', {
                            "storeId": this.$root.getStorage('storeId'),
                            "isSupplement":1,
                            // "confirmMoney": dataForm.confirmMoney,
                            "operateTime":dataForm.operateTime,//操作时间
                            "payment":payment,
                            "weddingOrderId": this.wedId,
                            "remark": dataForm.remark
                        }).then(res => {
                            this.$message.success('订单确认收款成功！');
                            this.resetForm();
                        }).catch(err => {
                            this.$message.error(err.msg);
                        })
                    } else {
                        return false;
                    }
                });
            },
            getSummaries(param) {
                const {columns, data} = param;
                const sums = ['累计收款', '', '', '', ''];
                var sum = 0;
                for (var i = 0, len = data.length; i < len; i++) {
                    sum += Number((data[i].confirmType == 1 ? '-' : '') + Number(data[i].confirmMoney));
                }
                sums[5] = sum;
                return sums;
            },
            resetForm(){
                this.$emit('refreshList');
                this.$emit('update:visible', false);
            }

        }
    }
</script>

<style scoped>

</style>